import { useEffect } from "react";

const SELECTOR = ".reveal:not(.in), .mask:not(.in)";

// Blendet .reveal- und .mask-Elemente ein, sobald sie in den Viewport kommen.
// Beobachtet auch später gerenderte Elemente (API-Daten, Tabwechsel).
// .mask ist anfangs komplett per clip-path verdeckt; dafür meldet der Observer
// keine Sichtbarkeit, deshalb wird stattdessen das Elternelement beobachtet.
export default function useReveal(rootRef, key) {
    useEffect(() => {
        const root = rootRef.current;
        if (!root) return undefined;

        if (!("IntersectionObserver" in window)) {
            root.querySelectorAll(SELECTOR).forEach((el) => el.classList.add("in"));
            return undefined;
        }

        const targets = new Map(); // beobachtetes Element → einzublendende Elemente
        const io = new IntersectionObserver(
            (entries) =>
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    (targets.get(entry.target) || []).forEach((el) => el.classList.add("in"));
                    targets.delete(entry.target);
                    io.unobserve(entry.target);
                }),
            { threshold: 0.12, rootMargin: "0px 0px -6% 0px" },
        );
        const observe = () =>
            root.querySelectorAll(SELECTOR).forEach((el) => {
                const target = el.classList.contains("mask") ? el.parentElement : el;
                const list = targets.get(target) || [];
                if (list.includes(el)) return;
                targets.set(target, [...list, el]);
                io.observe(target);
            });
        observe();

        const mo = new MutationObserver(observe);
        mo.observe(root, { childList: true, subtree: true });

        return () => {
            io.disconnect();
            mo.disconnect();
        };
    }, [rootRef, key]);
}
